import { render } from "./CreateArticleComponent.vue?vue&type=template&id=c2a33cfc&scoped=true"
import script from "./CreateArticleComponent.vue?vue&type=script&lang=js"
export * from "./CreateArticleComponent.vue?vue&type=script&lang=js"

import "./CreateArticleComponent.vue?vue&type=style&index=0&id=c2a33cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a33cfc"]])

export default __exports__